import "shared/styles/Sidebar.css";
import React, {memo} from "react";
import {User} from "../types";
import {useNavigate} from "react-router-dom";
import {Role} from "features/auth";

const UserComponent = ({isActive, isMe, user: {login, role, user_id}}: { user: User, isActive: boolean, setActiveUser: React.Dispatch<React.SetStateAction<User | undefined>>, isMe: boolean }) => {
    const navigate = useNavigate();
    
    return (
        <div className={`category-container category-container-${isActive ? "" : "in"}active`}
             onClick={() => navigate(`/users/${user_id}`)}>
            <p className="cat-name">{login} ({Role[role]}){isMe? " (Me)" : ""}</p>
        </div>
    );
}

export default memo(UserComponent);